var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeaderBgBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 50,
    viewBox: "0 0 243 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.7558 39.1116C76.4877 39.1116 76.4877 34.3833 76.4877 34.3833C76.4877 34.3833 76.4877 29.655 71.7558 29.655C67.0239 29.655 67.0239 31.7719 67.0239 34.3833C67.0239 36.9947 67.0239 39.1116 71.7558 39.1116Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4318 28.304C77.8396 28.304 77.8396 22.9002 77.8396 22.9002C77.8396 22.9002 77.8396 17.4964 72.4318 17.4964C67.0239 17.4964 67.0239 19.9158 67.0239 22.9002C67.0239 25.8846 67.0239 28.304 72.4318 28.304Z",
    fill: "#819FFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_367_6859)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1267 3C67.2779 3 72.0057 7.66692 72.0057 14.6673V21.6677C72.0057 24.6344 70.7829 27.6012 68.6405 29.8006C70.5892 30.9674 72.0057 32.8793 72.0057 34.7911C72.0057 40.9164 67.159 45 59.889 45H14.969C11.9398 45 11.334 44.4895 11.334 41.9373V33.335V28.6658V15.834C11.334 8.83365 17.2735 3 24.5435 3H60.1267Z",
    fill: "#CDD9FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4298 32.6057H30.0777C27.6692 32.6057 27.6689 33.189 27.6689 34.3557C27.6689 35.5225 28.8733 37.2726 36.0998 37.2726H55.4078C62.6342 37.2726 63.8386 35.5225 63.8386 34.3557C63.8386 33.189 63.8384 32.6057 61.4298 32.6057Z",
    fill: "#FF8F5C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.473 6.58301H61.2003C66.1716 6.58301 69.0885 10.6666 69.0885 15.1767V18.9258C69.0885 23.1887 65.0048 27.5841 60.0335 27.5841H31.473C26.2723 27.5841 22.418 24.3554 22.418 20.0925V15.1767C22.418 9.74708 26.2723 6.58301 31.473 6.58301Z",
    fill: "#527BFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1483 24.4661C40.6382 24.4661 44.278 21.0708 44.278 16.8824C44.278 12.694 40.6382 9.29865 36.1483 9.29865C31.6584 9.29865 28.0186 12.694 28.0186 16.8824C28.0186 21.0708 31.6584 24.4661 36.1483 24.4661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3289 24.4661C62.8188 24.4661 66.4586 21.0708 66.4586 16.8824C66.4586 12.694 62.8188 9.29865 58.3289 9.29865C53.839 9.29865 50.1992 12.694 50.1992 16.8824C50.1992 21.0708 53.839 24.4661 58.3289 24.4661Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08393 39.1116C12.8158 39.1116 12.8158 36.9946 12.8158 34.3832C12.8158 31.7719 12.8158 29.6549 8.08393 29.6549C3.35206 29.6549 3.35205 34.3832 3.35205 34.3832C3.35205 34.3832 3.35206 39.1116 8.08393 39.1116Z",
    fill: "#9AB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40786 28.304C12.8157 28.304 12.8157 25.8846 12.8157 22.9002V22.9002C12.8157 19.9158 12.8157 17.4964 7.40786 17.4964C2 17.4964 2 22.9002 2 22.9002C2 22.9002 2.00001 28.304 7.40786 28.304Z",
    fill: "#819FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_367_6859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8798 38V10H93.3598C95.2798 10 96.9598 10.2933 98.3998 10.88C99.8398 11.4667 100.96 12.36 101.76 13.56C102.56 14.7333 102.96 16.2 102.96 17.96C102.96 19.0533 102.68 20.0667 102.12 21C101.587 21.9067 100.827 22.6933 99.8398 23.36C101.147 24.0267 102.147 24.92 102.84 26.04C103.56 27.1333 103.92 28.4533 103.92 30C103.92 31.7067 103.533 33.16 102.76 34.36C101.987 35.56 100.907 36.4667 99.5198 37.08C98.1332 37.6933 96.5065 38 94.6398 38H83.8798ZM89.2398 33.16H94.1198C95.4265 33.16 96.4532 32.84 97.1998 32.2C97.9465 31.5333 98.3198 30.6533 98.3198 29.56C98.3198 28.4133 97.9065 27.52 97.0798 26.88C96.2532 26.2133 95.1198 25.88 93.6798 25.88H89.2398V33.16ZM89.2398 21.4H93.4798C94.6798 21.4 95.6265 21.0933 96.3198 20.48C97.0132 19.8667 97.3598 19 97.3598 17.88C97.3598 16.76 96.9732 15.8933 96.1998 15.28C95.4265 14.6667 94.3732 14.36 93.0398 14.36H89.2398V21.4ZM116.012 38.48C113.985 38.48 112.172 38.04 110.572 37.16C108.999 36.2533 107.759 35.0133 106.852 33.44C105.972 31.8667 105.532 30.0533 105.532 28C105.532 25.9467 105.972 24.1333 106.852 22.56C107.732 20.9867 108.959 19.76 110.532 18.88C112.105 17.9733 113.905 17.52 115.932 17.52C117.985 17.52 119.799 17.9733 121.372 18.88C122.945 19.76 124.172 20.9867 125.052 22.56C125.932 24.1333 126.372 25.9467 126.372 28C126.372 30.0533 125.932 31.8667 125.052 33.44C124.172 35.0133 122.945 36.2533 121.372 37.16C119.825 38.04 118.039 38.48 116.012 38.48ZM116.012 33.6C116.999 33.6 117.865 33.36 118.612 32.88C119.359 32.4 119.932 31.7467 120.332 30.92C120.759 30.0667 120.972 29.0933 120.972 28C120.972 26.9067 120.759 25.9467 120.332 25.12C119.905 24.2667 119.305 23.6 118.532 23.12C117.785 22.64 116.919 22.4 115.932 22.4C114.972 22.4 114.105 22.64 113.332 23.12C112.585 23.6 111.999 24.2667 111.572 25.12C111.145 25.9467 110.932 26.9067 110.932 28C110.932 29.0933 111.145 30.0667 111.572 30.92C111.999 31.7467 112.599 32.4 113.372 32.88C114.145 33.36 115.025 33.6 116.012 33.6ZM137.094 38.48C134.881 38.48 133.201 37.9333 132.054 36.84C130.934 35.7467 130.374 34.1867 130.374 32.16V11.76H135.654V31C135.654 31.8533 135.841 32.5067 136.214 32.96C136.588 33.3867 137.134 33.6 137.854 33.6C138.121 33.6 138.414 33.5467 138.734 33.44C139.054 33.3067 139.388 33.12 139.734 32.88L141.574 36.84C140.934 37.32 140.214 37.7067 139.414 38C138.641 38.32 137.868 38.48 137.094 38.48ZM127.134 22.48V18H140.654V22.48H127.134ZM143.708 38V33.96C143.708 33.1867 143.948 32.3333 144.428 31.4C144.908 30.4667 145.575 29.5333 146.428 28.6C147.281 27.6667 148.281 26.8 149.428 26L153.668 22.96C154.255 22.56 154.801 22.1067 155.308 21.6C155.841 21.0933 156.268 20.5467 156.588 19.96C156.935 19.3467 157.108 18.76 157.108 18.2C157.108 17.5067 156.935 16.88 156.588 16.32C156.268 15.76 155.788 15.32 155.148 15C154.508 14.68 153.721 14.52 152.788 14.52C151.988 14.52 151.268 14.68 150.628 15C150.015 15.32 149.508 15.7467 149.108 16.28C148.708 16.8133 148.428 17.3867 148.268 18L142.628 17.04C142.895 15.7067 143.468 14.4667 144.348 13.32C145.228 12.1733 146.375 11.2533 147.788 10.56C149.228 9.84 150.855 9.48 152.668 9.48C154.748 9.48 156.535 9.85333 158.028 10.6C159.521 11.3467 160.668 12.3733 161.468 13.68C162.295 14.96 162.708 16.4533 162.708 18.16C162.708 19.8933 162.228 21.44 161.268 22.8C160.335 24.1333 159.041 25.3867 157.388 26.56L153.588 29.32C152.815 29.8533 152.148 30.44 151.588 31.08C151.028 31.72 150.601 32.4267 150.308 33.2H163.068V38H143.708ZM166.112 38V10H171.392V34.28L171.112 38H166.112ZM177.432 38.48C175.752 38.48 174.325 38.0533 173.152 37.2C172.005 36.3467 171.125 35.1333 170.512 33.56C169.899 31.9867 169.592 30.1333 169.592 28C169.592 25.84 169.899 23.9867 170.512 22.44C171.125 20.8667 172.005 19.6533 173.152 18.8C174.325 17.9467 175.752 17.52 177.432 17.52C179.272 17.52 180.859 17.9467 182.192 18.8C183.552 19.6533 184.605 20.8667 185.352 22.44C186.099 23.9867 186.472 25.84 186.472 28C186.472 30.1333 186.099 31.9867 185.352 33.56C184.605 35.1333 183.552 36.3467 182.192 37.2C180.859 38.0533 179.272 38.48 177.432 38.48ZM176.072 33.64C177.032 33.64 177.872 33.4 178.592 32.92C179.339 32.44 179.925 31.7733 180.352 30.92C180.779 30.0667 180.992 29.0933 180.992 28C180.992 26.9067 180.779 25.9333 180.352 25.08C179.952 24.2267 179.379 23.5733 178.632 23.12C177.912 22.64 177.072 22.4 176.112 22.4C175.205 22.4 174.392 22.64 173.672 23.12C172.952 23.6 172.392 24.2667 171.992 25.12C171.592 25.9467 171.392 26.9067 171.392 28C171.392 29.0933 171.592 30.0667 171.992 30.92C172.392 31.7733 172.939 32.44 173.632 32.92C174.352 33.4 175.165 33.64 176.072 33.64ZM189.7 38V10H195.66L203.82 22.08L211.98 10H217.9V38H212.46V18.56L203.82 31.28L195.18 18.6V38H189.7ZM231.277 38.48C229.304 38.48 227.557 38.04 226.037 37.16C224.517 36.2533 223.317 35.0133 222.437 33.44C221.584 31.8667 221.157 30.0533 221.157 28C221.157 25.9467 221.597 24.1333 222.477 22.56C223.384 20.9867 224.61 19.76 226.157 18.88C227.73 17.9733 229.53 17.52 231.557 17.52C233.317 17.52 234.93 17.9867 236.397 18.92C237.89 19.8267 239.077 21.1733 239.957 22.96C240.864 24.72 241.317 26.8667 241.317 29.4H226.157L226.637 28.92C226.637 29.9067 226.877 30.7733 227.357 31.52C227.864 32.24 228.504 32.8 229.277 33.2C230.077 33.5733 230.93 33.76 231.837 33.76C232.93 33.76 233.824 33.5333 234.517 33.08C235.21 32.6 235.744 31.9867 236.117 31.24L240.837 33.08C240.277 34.2 239.544 35.1733 238.637 36C237.757 36.8 236.704 37.4133 235.477 37.84C234.25 38.2667 232.85 38.48 231.277 38.48ZM226.917 25.96L226.437 25.48H236.077L235.637 25.96C235.637 25 235.41 24.24 234.957 23.68C234.504 23.0933 233.944 22.6667 233.277 22.4C232.637 22.1333 232.01 22 231.397 22C230.784 22 230.13 22.1333 229.437 22.4C228.744 22.6667 228.144 23.0933 227.637 23.68C227.157 24.24 226.917 25 226.917 25.96Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_367_6859",
    x: 65.0239,
    y: 17.4964,
    width: 12.8159,
    height: 25.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_367_6859",
    x: 9.33398,
    y: 3,
    width: 62.6719,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_367_6859",
    x: 6.33398,
    y: 0,
    width: 68.6719,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_367_6859",
    x: 27.6689,
    y: 32.6057,
    width: 36.1694,
    height: 5.66693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "shape",
    result: "effect1_innerShadow_367_6859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_367_6859",
    x: 20.418,
    y: 2.58301,
    width: 52.6704,
    height: 27.0012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72 0 0 0 0 0.786316 0 0 0 0 1 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-lighter",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_367_6859",
    x: 26.0186,
    y: 7.29865,
    width: 42.4399,
    height: 19.1675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_367_6859",
    x: 0,
    y: 17.4964,
    width: 12.8159,
    height: 25.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_367_6859",
    x: 79.8799,
    y: 9.47998,
    width: 161.437,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "plus-darker",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_367_6859"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_367_6859",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeaderBgBlue);
export default __webpack_public_path__ + "static/media/logo-header-bg-blue.e6268f0b00ffdbb31f13bdeb0347dcde.svg";
export { ForwardRef as ReactComponent };